export default __webpack_public_path__ + "static/pierre.ricadat-1aac44abc3e7f816eec1ea23400ad3e0.png";